import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '备注',
    textProp: 'algTitle',
    type: 'LSI_ALG',
}
